import "./css/fontawesome/css/all.min.css";
import './styles.css';
import './main.css';
import './js/elm-pep'; // polyfill for PointerEvent
import { init as imageSelector } from './js/portImageSelector';
import { init as ga } from './js/portGA';
import { init as browser } from './js/browser';
import { init as fileSaver } from './js/portfilesaver';
import { Elm } from './elm/Main.elm';
import registerServiceWorker from './js/registerServiceWorker';
import unregister from './js/registerServiceWorker';

const configString = localStorage.getItem("memory-quiz-config");
const tagsString = localStorage.getItem("memory-quiz-tags");

var config;
if (configString) {
  config = JSON.parse(configString);
} else {
  config = {
    initialTimeout: 18 * 1000,
    speakEnglish: false,
    timeBonus: false,
  };
}
var tags;
if (tagsString) {
  tags = JSON.parse(tagsString);
} else {
  tags = []
}
const app = Elm.Main.init({
  node: document.getElementById('root'),
  flags: {
    origin: window.location.origin,
    config: config,
    tags: tags,
    history: localStorage.getItem("history") || ""
  }
});

browser(app);
ga(app);
imageSelector(app);
fileSaver(app);

function downloadSampleFile(im, tags) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', `/text/${im}.txt`, true);

  xhr.onload = function (event) {
    if (this.status == 200) {
      app.ports.quizesDownloaded.send(
        {
          quizes: this.responseText.split("\n"),
          tags: tags
        });
    } else {
      console.log(`not successful: ${this.status}`)
    }
  };

  xhr.send(null);
}

const lastPlayedString = localStorage.getItem("memory-quiz-last-played");
let lastPlayed = Date.now();
if (lastPlayedString) {
  lastPlayed = JSON.parse(lastPlayedString);
  console.log(`last played at ${new Date(lastPlayed)}`);
}
else {
  console.log(`This is the first time to play the game`);
  downloadSampleFile("sample", ["中学受験", "社会", "地理"]);
}
localStorage.setItem("memory-quiz-last-played", JSON.stringify(Date.now()));

app.ports.saveLocalStorage.subscribe(({ key, value }) => {
  localStorage.setItem(key, value);
});

const dbname = "run-run-learn";
const dbversion = 4;

export function initDB(app) {
  const db = new Promise((resolve, reject) => {
    const openReq = indexedDB.open(dbname, dbversion);
    openReq.onupgradeneeded = function (ev) {
      const _db = ev.target.result;
      const transaction = ev.target.transaction;
      if (ev.oldVersion < 1 && dbversion >= 1) {
        upgrade1(_db, transaction);
      }
      if (ev.oldVersion < 2 && dbversion >= 2) {
        upgrade2(_db, transaction);
      }
      if (ev.oldVersion < 3 && dbversion >= 3) {
        upgrade3(_db, transaction);
      }
      if (ev.oldVersion < 4 && dbversion >= 4) {
        upgrade4(_db, transaction);
      }
    }
    openReq.onsuccess = function (ev) {
      app.ports.questionReady.send({ name: dbname, version: dbversion });
      resolve(ev.target.result);
    }
  });

  function upgrade1(_db, transaction) {
    const store = _db.createObjectStore("questions",
      {
        keyPath: "key"
        , autoIncrement: false
      }
    );
    store.createIndex("review-schedule-index", "next_review",
      {
        unique: false,
        multiEntry: false,
      }
    );
  }

  function upgrade2(_db, transaction) {
    const store = transaction.objectStore("questions");
    store.createIndex("boost-index", "boost", {
      unique: false,
      multiEntry: false,
    });

    const req = store.openCursor();

    req.onsuccess = function (ev) {
      const cursor = ev.target.result;
      if (cursor) {
        const originalValue = cursor.value;
        if (!originalValue.hasOwnProperty("boost")) {
          const updateReq = cursor.update({ "boost": 0, ...originalValue });
          updateReq.onsuccess = function () { }
          updateReq.onerror = function (ev) {
            if (app.ports.dbError)
              app.ports.dbError.send(ev.target.error);
          }
        }
        cursor.continue();
      }
      else {
        console.log("DB successfully upgraded");
      }
    }
    req.onerror = function (ev) {
      if (app.ports.dbError)
        app.ports.dbError.send(ev);
    }
  }

  function upgrade3(_db, transaction) {
    const store = transaction.objectStore("questions");
    store.createIndex("mastering-index",
      "masteringCount",
      {
        unique: false,
        multiEntry: false,
      }
    );
    store.createIndex("total-index",
      "totalCount",
      {
        unique: false,
        multiEntry: false,
      }
    );

    const req = store.openCursor();

    req.onsuccess = function (ev) {
      const cursor = ev.target.result;
      if (cursor) {
        const originalValue = cursor.value;
        const total = originalValue.result.correctCount + originalValue.result.wrongCount;
        const mastering = originalValue.result.correctCount - originalValue.result.wrongCount;
        delete originalValue.result;
        const updateReq = cursor.update(
          {
            ...originalValue
            , ...{
              "masteringCount": mastering
              , "totalCount": total
            }
          });
        updateReq.onsuccess = function () { }
        updateReq.onerror = function (ev) {
          if (app.ports.dbError)
            app.ports.dbError.send(ev.target.error);
        }
        cursor.continue();
      }
      else {
        console.log("DB successfully upgraded");
      }
    }
    req.onerror = function (ev) {
      if (app.ports.dbError)
        app.ports.dbError.send(ev);
    }
  }

  function upgrade4(_db, transaction) {
    const tagsStore = _db.createObjectStore("tags",
      {
        keyPath: "tag"
        , autoIncrement: false
      }
    );
    tagsStore.createIndex("tag-count-index",
      "count",
      {
        unique: false,
        multiEntry: false,
      }
    )
    const questionsStore = transaction.objectStore("questions");
    questionsStore.createIndex("tag-index",
      "tags",
      {
        unique: false,
        multiEntry: true,
      }
    );

    tagsStore.put({ tag: "理科", count: 0 });
    tagsStore.put({ tag: "社会", count: 0 });
    tagsStore.put({ tag: "英語", count: 0 });
    tagsStore.put({ tag: "TOEIC", count: 0 });

    const req = questionsStore.openCursor();
    let counter = 0;
    req.onsuccess = function (ev) {
      const cursor = ev.target.result;
      if (cursor) {
        const originalValue = cursor.value;
        const updateReq = cursor.update(
          {
            ...originalValue
            , ...{
              "tags": ["中学受験"]
            }
          });
        updateReq.onsuccess = function () { }
        updateReq.onerror = function (ev) {
          if (app.ports.dbError)
            app.ports.dbError.send(ev.target.error);
        }
        counter += 1;
        cursor.continue();
      }
      else {
        tagsStore.put({ tag: "中学受験", count: counter });
        console.log("DB successfully upgraded");
      }
    }
    req.onerror = function (ev) {
      if (app.ports.dbError)
        app.ports.dbError.send(ev);
    }
  }

  app.ports.getTags.subscribe(async (prefix) => {
    const dbinstance = await db;
    const transaction = dbinstance.transaction(["tags"], "readonly");
    const store = transaction.objectStore("tags");
    const req = store.openCursor(IDBKeyRange.lowerBound(prefix, false));

    const tags = await cursorQuery(req, 10, (({ tag }) => tag.startsWith(prefix)));
    app.ports.gotTags.send(tags.map(({ tag }) => tag));
  });

  async function getAsync(store, key) {
    const req = store.get(key);
    return new Promise((resolve, reject) => {
      req.onsuccess = function (ev) {
        const result = ev.target.result;
        resolve(result);
      }
      req.onerror = function (e) {
        reject(e)
      }
    })
  }
  async function putAsync(store, item) {
    const req = store.put(item);
    return new Promise((resolve, reject) => {
      req.onsuccess = function (ev) {
        resolve(ev.target.result)
      }
      req.onerror = function (ev) {
        reject(ev)
      }
    });
  }
  function difference(before, after) {
    const removing = before.filter((v) => !after.includes(v));
    const adding = after.filter((v => !before.includes(v)));
    return { removing, adding };
  }
  app.ports.updateQuestions.subscribe(async (questions) => {
    console.log(`updateQuestions: ${JSON.stringify(questions)}`)
    const dbinstance = await db;
    const transaction = dbinstance.transaction(["questions", "tags"], "readwrite");
    const store = transaction.objectStore("questions");
    const tagsStore = transaction.objectStore("tags");

    async function putQuestion(item) {
      console.log(`put[1] ${JSON.stringify(item)}`);
      let tags;
      try {
        const existing = await getAsync(store, item.key);
        tags = existing.tags || [];
      } catch (e) {
        tags = []
      }
      const { adding, removing } = difference(tags, item.tags);
      console.log(`original: ${JSON.stringify(tags)}, new: ${JSON.stringify(item.tags)}`);
      console.log(`adding: ${JSON.stringify(adding)}`);
      console.log(`removing: ${JSON.stringify(removing)}`);
      for (const tag of removing) {
        const tagEntry = await getAsync(tagsStore, tag);
        let count = 0
        if (tagEntry) {
          count = tagEntry.count;
        }
        await putAsync(tagsStore, { tag, count: count - 1 })
      }
      for (const tag of adding) {
        const tagEntry = await getAsync(tagsStore, tag);
        let count = 0
        if (tagEntry) {
          count = tagEntry.count;
        }
        await putAsync(tagsStore, { tag, count: count + 1 })
      }

      await putAsync(store, item);
    }
    for (let question of questions) {
      await putQuestion(question)
    }
  });

  app.ports.getQuiz.subscribe(async (key) => {
    const dbinstance = await db;
    const transaction = dbinstance.transaction(["questions"], "readonly");
    const store = transaction.objectStore("questions");

    try {
      const q = await getAsync(store, key);
      app.ports.gotQuiz.send(q);
    } catch (e) {
      console.log(`GOT ERROR: ${JSON.stringify(e)}`)
      if (app.ports.dbError)
        app.ports.dbError.send(e);
    }
  });

  app.ports.deleteQuiz.subscribe(async (key) => {
    const dbinstance = await db;
    const transaction = dbinstance.transaction(["questions", "tags"], "readwrite");
    const store = transaction.objectStore("questions");
    const tagsStore = transaction.objectStore("tags");

    console.log(`deleteQuiz: ${key}`);
    async function deleteItem(key) {
      const entry = await getAsync(store, key);
      if (entry) {
        for (const tag of entry.tags) {
          const { count } = await getAsync(tagsStore, tag);
          await putAsync(tagsStore, { tag, count: count - 1 })
        }
      }
      const req = store.delete(key);
      return new Promise((resolve, reject) => {
        req.onsuccess = function (ev) {
          console.log(`delete resolve: ${key}`)
          resolve(ev.target.result)
        }
        req.onerror = function (ev) {
          reject(ev)
        }
      })
    }
    await deleteItem(key);
    console.log(`DELETED : ${key}`)
    app.ports.deleteQuizResult.send({ key, deleted: true });
  });

  app.ports.confirm.subscribe(({ message, result }) => {
    const answer = window.confirm(message);
    app.ports.confirmed.send({ answer, result });
  });

  function cursorQuery(req, count, predicate) {
    if (typeof predicate != "function") {
      predicate = (_) => true;
    }
    return new Promise((resolve, reject) => {
      var i = 0;
      const items = [];
      var cursor;
      req.onsuccess = function (ev) {
        cursor = ev.target.result;
        //app.ports.idbCursorOpened.send({token});
        if (cursor && i < count) {
          if (predicate(cursor.value)) {
            i++;
            items.push(cursor.value)
          }
          cursor.continue();
        }
        else {
          resolve(items)
        }
      }
      req.onerror = function (ev) {
        reject(ev);
      }
    });
  }

  app.ports.nextScheduledReview &&
    app.ports.nextScheduledReview.subscribe(async ({ count, tags }) => {
      try {
        const dbinstance = await db;
        const transaction = dbinstance.transaction(["questions"], "readonly");
        const store_ = transaction.objectStore("questions");
        const scheduleIndex = store_.index("review-schedule-index");
        const masteringIndex = store_.index("mastering-index");
        const now = Date.now();
        const scheduleKeyRange = IDBKeyRange.upperBound(now, false);
        const masteringKeyRange = IDBKeyRange.upperBound(0, true);
        const req1 = scheduleIndex.openCursor(scheduleKeyRange, "prev");
        const scheduledItems = await cursorQuery(req1, 10, q => (tags.length == 0) || tags.every(t => q.tags.includes(t)));

        const req2 = scheduleIndex.openCursor(scheduleKeyRange, "next", (q => q.masteringCount >= 0));
        const oldItems = await cursorQuery(req2, 10, q => tags.every(t => q.tags.includes(t)));

        const req3 = masteringIndex.openCursor(masteringKeyRange, "next");
        const weakItems = await cursorQuery(req3, 10, (q => q.next_review < now && tags.every(t => q.tags.includes(t))));

        app.ports.gotNextScheduledReview.send(
          scheduledItems
            .concat(oldItems)
            .concat(weakItems)
        );
      } catch (e) {
        if (app.ports.dbError)
          app.ports.dbError.send(e);
      }
    });

  app.ports.getQuizes &&
    app.ports.getQuizes.subscribe(async ({ count, page }) => {
      const dbinstance = await db;
      const transaction = dbinstance.transaction(["questions"], "readonly");
      const store_ = transaction.objectStore("questions");
      const index_ = store_.index("review-schedule-index");
      const req = index_.openCursor();
      const items = [];
      var skipCount = count * page;
      var skipped = false;
      var cursor;
      req.onsuccess = function (ev) {
        cursor = ev.target.result;
        if (cursor) {
          if (!skipped && skipCount > 0) {
            cursor.advance(skipCount)
            skipped = true;
            return;
          }
          if (items.length < count) {
            items.push(cursor.value)
            cursor.continue();
          }
          else {
            app.ports.gotAllQuizes.send(items);
            return;
          }
        }
        else {
          app.ports.gotAllQuizes.send(items);
        }
      }
      req.onerror = function (ev) {
        if (app.ports.dbError)
          app.ports.dbError.send(ev);
      }
    });

  function countPromise(index_, keyrange) {
    return new Promise((resolve, reject) => {
      const req = index_.count(keyrange);
      req.onsuccess = (ev) => {
        resolve(ev.target.result)
      }
      req.onerror = (err) => reject(err);
    });
  }

  app.ports.getStatistics &&
    app.ports.getStatistics.subscribe(async _ => {
      const dbinstance = await db;
      const transaction = dbinstance.transaction(["questions"], "readonly");
      const store_ = transaction.objectStore("questions");
      const weakKeyRange = IDBKeyRange.upperBound(0, true);
      const learningKeyRange = IDBKeyRange.bound(0, 5, false, true);
      const masteringKeyRange = IDBKeyRange.bound(5, 10, false, true);
      const masteredKeyRange = IDBKeyRange.lowerBound(10, false);

      const index_total = store_.index("total-index");
      const notYetCount = await countPromise(index_total, 0);

      const index_mastering = store_.index("mastering-index");
      const weakCount = await countPromise(index_mastering, weakKeyRange);
      const learningCount = await countPromise(index_mastering, learningKeyRange);
      const masteringCount = await countPromise(index_mastering, masteringKeyRange);
      const masteredCount = await countPromise(index_mastering, masteredKeyRange);

      const notyetKey = "notyet";
      const learningCountKey = "learning";
      const weakKey = "weak";
      const masteringKey = "mastering";
      const masteredKey = "mastered";

      const items = {}
      items[notyetKey] = notYetCount;
      items[learningCountKey] = learningCount - notYetCount;
      items[weakKey] = weakCount;
      items[masteringKey] = masteringCount;
      items[masteredKey] = masteredCount;

      try {
        app.ports.gotStatistics.send(items);
      } catch (e) {
        if (app.ports.dbError)
          app.ports.dbError.send(e);
      }
    });

  app.ports.getAllEntries.subscribe(async (tags) => {
    const dbinstance = await db;
    const transaction = dbinstance.transaction(["questions", "tags"], "readonly");
    const tagsStore = transaction.objectStore("tags");
    const tagEntries = []
    for (const tag of tags) {
      const tagEntry = await getAsync(tagsStore, tag);
      tagEntries.push(tagEntry);
    }
    const sortedTagEntries = tagEntries.sort((e1, e2) => e1.count - e2.count)
    const tagToFind = sortedTagEntries[0];

    const questionsStore = transaction.objectStore("questions");
    const index_ = questionsStore.index("tag-index")
    const req = (tagToFind ? index_ : questionsStore).openCursor(tagToFind && tagToFind.tag);
    const items = [];
    var cursor;
    req.onsuccess = function (ev) {
      cursor = ev.target.result;
      if (cursor) {
        if (tags.length == 0 ||
          tags.every(t => cursor.value.tags.includes(t))) {
          items.push([cursor.value.key, cursor.value])
        }
        cursor.continue();
      }
      else {
        app.ports.gotEntries.send(items);
      }
    }
    req.onerror = function (ev) {
      if (app.ports.dbError)
        app.ports.dbError.send(ev);
    }
  });
}

const params = new URLSearchParams(window.location.search);
var tags = [];
if (params.has("t")) {
  tags = params.getAll("t");
}

if (params.has("im")) {
  const im = params.get("im");
  im.replace(/\W/g, '');
  downloadQuizFile(im, tags);
}
if (params.has("q")) {
  const questions = params.getAll("q");
  app.ports.quizesDownloaded.send(
    {
      quizes: questions,
      tags: tags,
    });
}

initDB(app);

//registerServiceWorker();
unregister()
